// extracted by mini-css-extract-plugin
module.exports = {"imageLabelText":"image-label_imageLabelText__VRvjG","imageRatio":"image-label_imageRatio__6ZgEZ","noImage":"image-label_noImage__9fKs1"};